import Header from "./Header";
import Loader from "./Loader";
import { useEffect, useState } from "react";
import Footer from "./footer";
import "../CSS/ContactUs.css";

const ContactUs = () => {
    const [isLoader, setIsLoader] = useState(true);
    const [formData, setFormData] = useState({
        firstName: "",
        lastName: "",
        email: "",
        message: "",
    });

    const [errors, setErrors] = useState({
        firstName: "",
        lastName: "",
        email: "",
    });

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData({
            ...formData,
            [name]: value,
        });
    };

    const validateEmail = (email) => {
        // Basic email validation
        const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return re.test(String(email).toLowerCase());
    };

    const validateForm = () => {
        const { firstName, lastName, email } = formData;
        const errorsCopy = { ...errors };

        errorsCopy.firstName = firstName.trim() === "" ? "First name is required" : "";
        errorsCopy.lastName = lastName.trim() === "" ? "Last name is required" : "";
        errorsCopy.email = !validateEmail(email) ? "Invalid email address" : "";

        setErrors(errorsCopy);

        return (
            errorsCopy.firstName === "" && errorsCopy.lastName === "" && errorsCopy.email === ""
        );
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        const isValid = validateForm();

        if (isValid) {
            // Here you can handle form submission, e.g., sending data to a server
            console.log("Form submitted:", formData);
            // Assuming submission takes some time, simulating it with a setTimeout
            setTimeout(() => setIsLoader(false), 1700);
            const data = { ...formData }

            const requestOptions = {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(data)
            }

            const apiUrl = "http://localhost:8080/api/customer/contactus";
            fetch(apiUrl, requestOptions).then(
                response => {
                    console.log(response)
                    if (response.status === 200) {
                        console.log("success")
                        setFormData({
                            firstName: "",
                            lastName: "",
                            email: "",
                            message: "",
                        })
                    }
                    else {
                        console.log("ERROR")
                    }
                }
            ).catch(error => {
                // setError4(error)
                console.error(error)
            });
        } else {
            console.log("Form has errors. Please correct them.");
        }
    };

    useEffect(() => {
        setTimeout(() => setIsLoader(false), 1700);
    }, []);

    return (
        <div className="flex-container">
            <Header />
            {isLoader ? (
                <Loader />
            ) : (
                <div className="contact-us-background " style={{flexGrow: "1"}}>
                    <div className="contact-form-container">
                        <h2>Contact Us</h2>
                        <form onSubmit={handleSubmit}>
                            <div>
                                <label htmlFor="firstName">First Name:</label>
                                <input
                                    type="text"
                                    id="firstName"
                                    name="firstName"
                                    value={formData.firstName}
                                    onChange={handleInputChange}
                                    required
                                />
                                <span className="error">{errors.firstName}</span>
                            </div>
                            <div>
                                <label htmlFor="lastName">Last Name:</label>
                                <input
                                    type="text"
                                    id="lastName"
                                    name="lastName"
                                    value={formData.lastName}
                                    onChange={handleInputChange}
                                    required
                                />
                                <span className="error">{errors.lastName}</span>
                            </div>
                            <div>
                                <label htmlFor="email">Email:</label>
                                <input
                                    type="email"
                                    id="email"
                                    name="email"
                                    value={formData.email}
                                    onChange={handleInputChange}
                                    required
                                />
                                <span className="error">{errors.email}</span>
                            </div>
                            <div>
                                <label htmlFor="message">Message:</label>
                                <textarea
                                    id="message"
                                    name="message"
                                    value={formData.message}
                                    onChange={handleInputChange}
                                    required
                                />
                            </div>
                            <button type="submit">Submit</button>
                        </form>
                    </div>
                </div>
            )}
            <Footer />
        </div>
    );
};

export default ContactUs;
